import React from 'react'

export default function Hero() {
    return (
        <>
            <section className="hero_area pt-120 pb-16 position-relative">
                <div className="container vh-78 z-1 d-flex justify-content-center align-items-center">
                    <div className="row justify-content-center mt-8 mt-sm-13 mt-md-0">
                        <div className="col-xl-9">
                            <div className="hero_area__content pt-17 pt-sm-20 pt-lg-0 text-center">
                                <h1 className="display-three mb-5 mb-md-6 wow fadeInUp">Aarma (ARMA) Presale</h1>
                                <p className="mb-8 mb-md-10 wow fadeInUp">ARMA coin is the native currency for AarmaChain where it is used to pay for transaction gas, staking & other onchain activities.</p>
                                <div className="d-flex align-items-center justify-content-center flex-wrap gap-4 gap-md-6 mb-10 mb-md-13 wow fadeInUp">
                                    <a className="hero_area__content-btnone cmn-btn px-6 px-md-8 py-3 d-center gap-3" href="#Preesale">
                                        Buy ARMA
                                    </a>
                                    {/* <a className="hero_area__content-btntwo cmn-btn third-alt px-6 px-md-8 py-3 d-center gap-3" href="staking.html">Explore
                                        <i className="ti ti-chevron-right fs-five px-1 bg2-color rounded-3 fw-bolder" />
                                    </a> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hero_area__shape">
                    <img className="position-absolute rotated_animattwo" src="assets/images/hero-shape.png" alt="Shape" />
                </div>
                <div className="hero_area__lishtone">
                    <img className="position-absolute opacity-75" src="assets/images/lightone.png" alt="light" />
                </div>
                <div className="hero_area__lishttwo">
                    <img className="position-absolute opacity-75" src="assets/images/lighttwo.png" alt="light" />
                </div>
            </section>

        </>
    )
}
